import { useEffect, useRef, useState } from "react";
import { ChevronDown, Plus, Search } from "lucide-react";
import { api } from "@/lib/api";
import { ContactModal, contactTypeLabels } from "@/components/ContactModal";

export function ContactPicker({ value, onPick, typeFilter, addLabel, defaultTypes, testPrefix, placeholder }) {
  const [open, setOpen] = useState(false);
  const [term, setTerm] = useState("");
  const [contacts, setContacts] = useState([]);
  const [adding, setAdding] = useState(false);
  const boxRef = useRef(null);
  const load = () => api(`/contacts${typeFilter ? `?type=${typeFilter}` : ""}`).then(setContacts).catch(() => {});
  useEffect(() => { load(); }, [typeFilter]); // eslint-disable-line
  useEffect(() => {
    const onDown = (e) => { if (boxRef.current && !boxRef.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", onDown);
    return () => document.removeEventListener("mousedown", onDown);
  }, []);
  const filtered = contacts.filter((c) => c.name.toLowerCase().includes(term.toLowerCase()));
  const pick = (c) => { onPick(c); setOpen(false); setTerm(""); };
  return (
    <div className="contact-picker" ref={boxRef}>
      <div className={`cp-control ${open ? "open" : ""}`}>
        {open && <Search size={13} className="cp-icon" />}
        <input
          data-testid={`${testPrefix}-input`}
          value={open ? term : value || ""}
          placeholder={open ? "+ Ketik untuk mencari / menambahkan" : placeholder || "Pilih kontak..."}
          onFocus={() => { setOpen(true); setTerm(""); }}
          onChange={(e) => setTerm(e.target.value)}
        />
        <ChevronDown size={13} className="cp-caret" onMouseDown={(e) => { e.preventDefault(); setOpen((o) => !o); }} />
      </div>
      {open && (
        <div className="cp-list" data-testid={`${testPrefix}-list`}>
          <button type="button" className="cp-add" data-testid={`${testPrefix}-add-new`} onMouseDown={(e) => { e.preventDefault(); setAdding(true); setOpen(false); }}><Plus size={13} /> {addLabel}</button>
          {filtered.map((c, i) => (
            <button type="button" key={c.id} className={`cp-item ${c.name === value ? "selected" : ""}`} data-testid={`${testPrefix}-option-${i}`} onMouseDown={(e) => { e.preventDefault(); pick(c); }}>
              {c.name} <span className="cp-type">({contactTypeLabels(c)})</span>
            </button>
          ))}
          {filtered.length === 0 && <div className="cp-empty" data-testid={`${testPrefix}-empty`}>Tidak ditemukan — gunakan tombol "+ {addLabel}" di atas</div>}
        </div>
      )}
      {adding && (
        <ContactModal defaultTypes={defaultTypes} defaultName={term}
          onClose={() => setAdding(false)}
          onSaved={(c) => { setAdding(false); setContacts((prev) => [c, ...prev]); onPick(c); }} />
      )}
    </div>
  );
}
